var _style, _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190.3 256.5",
    style: {
      enableBackground: "new 0 0 190.3 256.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E5252A;}\r\n\t.st1{fill:#ED676A;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.1,256.5h-126C14.4,256.5,0,242.1,0,224.4V32.1C0,14.4,14.4,0,32.1,0h86.1l72,73.9v150.4 C190.3,242.1,175.9,256.5,158.1,256.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.9,74.6 190.3,74.6 118.3,0 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.5,145.6c3.3-0.6,7.9-1,14.5-1c6.6,0,11.3,1.3,14.5,3.8c3.1,2.4,5.1,6.3,5.1,10.9s-1.5,8.6-4.4,11.2 c-3.6,3.4-9.1,5-15.4,5c-1.4,0-2.7-0.1-3.6-0.3v17H37.5V145.6z M48.1,167.1c0.9,0.2,2,0.3,3.6,0.3c5.7,0,9.2-2.9,9.2-7.6 c0-4.4-3-6.9-8.4-6.9c-2.1,0-3.6,0.1-4.4,0.4V167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,145.7c3.9-0.6,9.1-1.1,14.4-1.1c9.1,0,14.9,1.7,19.4,5.1c4.9,3.6,8,9.5,8,17.8c0,9.1-3.3,15.3-7.8,19.2 c-5,4.1-12.6,6.1-21.9,6.1c-5.5,0-9.5-0.4-12.1-0.7V145.7z M88.9,184.2c0.9,0.2,2.5,0.2,3.7,0.2c9.8,0.1,16.1-5.3,16.1-16.6 c0-9.8-5.8-15-15-15c-2.3,0-3.9,0.2-4.8,0.4V184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.2,145H156v8.8h-18.2v10.8h17v8.7h-17v19h-10.7V145z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ac1302e06f14e33bbfd9c47fa6325457.svg";
export { ForwardRef as ReactComponent };